import React, { useState, Component } from 'react';





class BoxDivider extends Component {
  // use a constructor if necessary
  constructor(props) {
    super(props);

    // this.state = {
    //   example: someInfo,
    // };
  }
  

  render() {
    const {cx, horisontal} = this.props;
    
    // console.log(horisontal)

    const cxBox = `bb ${horisontal ? 'w-10 h-3 br' : 'w-100 h-9 flex-1'}`

    return (
      <div className={`divider flex ${cx} ${horisontal ? 'flex-row' : 'flex-column'}`}>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${cxBox}`}></div>
        <div className={`${horisontal ? 'w-10 h-3 bb' : 'w-100 h-9'}`}></div>
      </div>
    
    );
  }
}


export default BoxDivider;